import { render, staticRenderFns } from "./ButtonIconCircle.vue?vue&type=template&id=46a4632e&scoped=true&lang=pug"
import script from "./ButtonIconCircle.vue?vue&type=script&lang=ts"
export * from "./ButtonIconCircle.vue?vue&type=script&lang=ts"
import style0 from "./ButtonIconCircle.vue?vue&type=style&index=0&id=46a4632e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a4632e",
  null
  
)

export default component.exports